"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subtitle = exports.Title = exports.BlankSlate = exports.PaddingTop40 = exports.MarginTop40 = exports.PublicProfileWrapper = exports.SharingWrapper = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./CompanyActivation.pc.css");
const SharingWrapper = ({ top, chooseYourAdventureVariant, dataTestId, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_a13d308d', '_b23fc821', '_pub-b23fc821', {
            '_b23fc821_top _pub-b23fc821_top top': top,
            '_b23fc821_choose-your-adventure-variant _pub-b23fc821_choose-your-adventure-variant choose-your-adventure-variant': chooseYourAdventureVariant,
        }), "data-testid": dataTestId }, children));
};
exports.SharingWrapper = SharingWrapper;
const PublicProfileWrapper = ({ dataTestId, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_485e95b8', '_b23fc821', '_pub-b23fc821'), "data-testid": dataTestId }, children));
};
exports.PublicProfileWrapper = PublicProfileWrapper;
const MarginTop40 = ({ children }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_a650f494', '_b23fc821', '_pub-b23fc821') }, children));
};
exports.MarginTop40 = MarginTop40;
const PaddingTop40 = ({ children }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_41e8d993', '_b23fc821', '_pub-b23fc821') }, children));
};
exports.PaddingTop40 = PaddingTop40;
const BlankSlate = ({ hasItems, dataTestId, img, title, description, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_22424f98', '_b23fc821', '_pub-b23fc821', '_b23fc821_v3', '_pub-b23fc821_v3', 'v3', { '_b23fc821_hasItems _pub-b23fc821_hasItems hasItems': hasItems }), "data-testid": dataTestId },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_6fd6367b', '_b23fc821', '_pub-b23fc821') },
            img && !hasItems && (react_1.default.createElement("img", { src: img, alt: "", className: "_b23fc821_illustration _b23fc821" })),
            react_1.default.createElement("h1", { className: (0, clsx_1.default)('_aa5543e2', '_b23fc821', '_pub-b23fc821') }, title),
            react_1.default.createElement("div", { className: (0, clsx_1.default)('_dd527374', '_b23fc821', '_pub-b23fc821') }, description),
            children && (react_1.default.createElement("div", { className: (0, clsx_1.default)('_ec2faeb0', '_b23fc821', '_pub-b23fc821') }, children)))));
};
exports.BlankSlate = BlankSlate;
const Title = ({ title, description }) => {
    return (react_1.default.createElement("h1", { className: (0, clsx_1.default)('_cc4c2eb4', '_b23fc821', '_pub-b23fc821') },
        title,
        description && (react_1.default.createElement("div", { className: (0, clsx_1.default)('_b2473aeb', '_b23fc821', '_pub-b23fc821') }, description))));
};
exports.Title = Title;
const Subtitle = ({ children }) => {
    return (react_1.default.createElement("h2", { className: (0, clsx_1.default)('_252f8b81', '_b23fc821', '_pub-b23fc821') }, children));
};
exports.Subtitle = Subtitle;
//# sourceMappingURL=CompanyActivation.js.map